import React, { useState } from 'react';
import { CloudfrontVideoFormat } from './CloudfrontVideoFormat';
import './example.scss';

const VideoPlaylistPage = () => {
  // Sample video list - replace with your actual video sources
  const videoList = [
    {
      id: 1,
      title: 'Video 1',
      source: 'c9030ca2400a29637ed7d7289d1f/480.m3u8', // HLS format
      thumbnail: '/Images/video1-thumb.jpg'
    },
    {
      id: 2,
      title: 'Video 2',
      source: '0f3ed57ed3560b50aec6407c510c/480.m3u8',
      thumbnail: '/Images/video2-thumb.jpg'
    },
    {
      id: 3,
      title: 'Video 3',
      source: 'd2ffd05bd293bd1ede0bf146eb24/480.m3u8', // Regular MP4 format
      thumbnail: '/Images/video3-thumb.jpg'
    },
    {
      id: 4,
      title: 'Video 4',
      source: '98d987a407e9afec9bcd4fe2471f/480.m3u8', // External URL
      thumbnail: '/Images/video4-thumb.jpg'
    },
    {
      id: 5,
      title: 'Video 5',
      source: 'f443636bf0534525eabf41d2a6c6/480.m3u8',
      thumbnail: '/Images/video5-thumb.jpg'
    },
    {
      id: 6,
      title: 'Video 6',
      source: '5fadcedf1795d7e61746cc2355b5/480.m3u8',
      thumbnail: '/Images/video6-thumb.jpg'
    },
    {
      id: 7,
      title: 'Video 7',
      source: 'c3e7bd8336a6c35de185cedd3666/480.m3u8',
      thumbnail: '/Images/video7-thumb.jpg'
    },
    {
      id: 8,
      title: 'Video 8',
      source: '98ad256f9d51ea70e6cb54296323/480.m3u8',
      thumbnail: '/Images/video8-thumb.jpg'
    },
    {
      id: 9,
      title: 'Video 9',
      source: '20cdb8e0910d6f6cdc7b44fb2f3d/480.m3u8',
      thumbnail: '/Images/video9-thumb.jpg'
    },
    {
      id: 10,
      title: 'Video 10',
      source: '464a3e52bbe912bd88a5c75e0a8f/480.m3u8',
      thumbnail: '/Images/video10-thumb.jpg'
    }
  ];

  const [currentVideoIndex, setCurrentVideoIndex] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handleVideoSelect = (index) => {
    setCurrentVideoIndex(index);
    setIsPlaying(true);
  };

  const handleVideoEnded = () => {
    // Auto-play next video in the list
    if (currentVideoIndex !== null && currentVideoIndex < videoList.length - 1) {
      setCurrentVideoIndex(currentVideoIndex + 1);
    } else {
      // All videos finished, return to playlist
      setIsPlaying(false);
      setCurrentVideoIndex(null);
    }
  };

  const handleClose = () => {
    setIsPlaying(false);
    setCurrentVideoIndex(null);
  };

  const handlePlayNext = () => {
    if (currentVideoIndex !== null && currentVideoIndex < videoList.length - 1) {
      setCurrentVideoIndex(currentVideoIndex + 1);
    }
  };

  const handlePlayPrevious = () => {
    if (currentVideoIndex !== null && currentVideoIndex > 0) {
      setCurrentVideoIndex(currentVideoIndex - 1);
    }
  };

  return (
    <div className="video-playlist-page">
      {!isPlaying ? (
        <div className="playlist-container">
          <h1 className="playlist-title">Video Playlist</h1>
          <div className="video-grid">
            {videoList.map((video, index) => (
              <div 
                key={video.id} 
                className="video-card"
                onClick={() => handleVideoSelect(index)}
              >
                <div className="video-thumbnail">
                  <div className="thumbnail-placeholder">
                    <div className="play-icon">▶</div>
                  </div>
                </div>
                <div className="video-info">
                  <h3 className="video-title">{video.title}</h3>
                  <p className="video-number">Video {index + 1} of {videoList.length}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="video-player-wrapper">
          <div className="player-controls">
            <button 
              className="control-btn"
              onClick={handlePlayPrevious}
              disabled={currentVideoIndex === 0}
            >
              ← Previous
            </button>
            <span className="current-video-info">
              Playing: {videoList[currentVideoIndex]?.title} 
              ({currentVideoIndex + 1}/{videoList.length})
            </span>
            <button 
              className="control-btn"
              onClick={handlePlayNext}
              disabled={currentVideoIndex === videoList.length - 1}
            >
              Next →
            </button>
          </div>
          
          <CloudfrontVideoFormat
            source={videoList[currentVideoIndex]?.source}
            ended={handleVideoEnded}
            close={handleClose}
            controls={true}
            onPlay={() => console.log('Video started playing')}
          />
        </div>
      )}
    </div>
  );
};

export default VideoPlaylistPage;

